// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sticky-header {
    position: sticky;
    top: 0;
    z-index: 1020; /* Ensure it stays on top */
    background-color: white; /* Prevent transparency */
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */
    font-family:'GT-Walsheim'
  }`, "",{"version":3,"sources":["webpack://./src/Screens/reportlisting.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa,EAAE,2BAA2B;IAC1C,uBAAuB,EAAE,yBAAyB;IAClD,wCAAwC,EAAE,oBAAoB;IAC9D;EACF","sourcesContent":[".sticky-header {\n    position: sticky;\n    top: 0;\n    z-index: 1020; /* Ensure it stays on top */\n    background-color: white; /* Prevent transparency */\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional shadow */\n    font-family:'GT-Walsheim'\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
